import { useRef } from "react";
import TagInput from "@/components/ui/TagInput";

interface CompanyTypeTagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function CompanyTypeTagInput({ value, onChange, disabled, placeholder }: CompanyTypeTagInputProps) {
  const previousValue = useRef<string[]>(value);

  const handleChange = async (newValue: string[]) => {
    const normalizedValue = newValue.slice(-1);
    const previous = previousValue.current;
    previousValue.current = normalizedValue;

    const added = normalizedValue.filter((v) => !previous.includes(v));
    for (const tag of added) {
      try {
        await fetch("/api/company-classification/terms", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ field: "companyType", label: tag, source: "user_created", confirmed: true }),
        });
      } catch (error) {
        console.error("[CompanyTypeTagInput] Failed to create:", error);
      }
    }

    onChange(normalizedValue);
  };

  return (
    <TagInput
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      suggestionsEndpoint="/api/company-classification/terms?field=companyType"
    />
  );
}
